import { css } from '@emotion/react'
import { s3URL } from '@mathflat/shared/@common/utils/s3'

import { typo } from '~/@common/styles'

const DailyLearningLockedSection = () => {
  return (
    <div css={S.Container}>
      <img
        src={s3URL.student('images/daily_learning_lock.svg')}
        alt="daily-learning-lock"
        width={35}
        height={35}
      />
      <div className="title">업데이트 예정!</div>
      <div className="description">
        지도 속의 문제들을 풀고
        <br />
        불꽃을 모을 수 있어요.
      </div>
      <img
        className="blur-image"
        src={s3URL.student('images/daily_learning_blur.svg')}
        alt="daily-learning-blur"
      />
    </div>
  )
}

export default DailyLearningLockedSection

const S = {
  Container: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 8px;
    border-radius: var(--Radius-300);
    background: var(--White);
    min-width: 385px;
    position: relative;
    overflow: hidden;
    > *:not(.blur-image) {
      position: relative;
      z-index: 1;
    }

    .title {
      ${typo.body01};
      font-weight: 700;
      color: var(--Colors-Blue-600);
    }
    .description {
      ${typo.heading05};
      font-weight: 700;
      text-align: center;
      color: var(--Colors-Gray-900);
    }

    .blur-image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
      z-index: 0;
    }
  `,
}
